export const CREATE_DIRECT_DEPOSIT_CONFIRMED =
  'direct-deposit-account/CREATE_DIRECT_DEPOSIT_CONFIRMED';
export const CREATE_DIRECT_DEPOSIT_CANCELLED =
  'direct-deposit-account/CREATE_DIRECT_DEPOSIT_CANCELLED';
export const OPEN_CONFIRMATION_MODAL =
  'direct-deposit-account/OPEN_CONFIRMATION_MODAL';
